import Flex from 'UIKit/Box/Flex'
import { useCountDown } from 'hooks/useCountdown'
import React from 'react'
import styled, { css } from 'styled-components'
import { FlexProps } from 'styled-system'

interface BonusItemCountdownProps {
  expiryDate: number
  onExpired?: () => void
}

const BonusItemCountdown: React.FC<BonusItemCountdownProps & FlexProps> = ({
  expiryDate,
  onExpired = () => {},
  ...props
}) => {
  const shudownTimeTextRef = useCountDown(
    expiryDate,
    (s, m, h, d) => {
      return `<div class='${d === 0 ? 'highlight' : ''}'>${d
        .toString()
        .padStart(2, '0')}</div><span>:</span> <div class='${h === 0 ? 'highlight' : ''}' >${h
        .toString()
        .padStart(2, '0')}</div> <span>:</span> <div class='${m === 0 ? 'highlight' : ''}'>${m
        .toString()
        .padStart(2, '0')}</div> <span>:</span> <div>${s.toString().padStart(2, '0')}</div>`
    },
    () => {
      onExpired()
    },
  )
  const isHighlightExpiryDate = expiryDate - Date.now() < 86400000
  return <StyledCountdownContent ref={shudownTimeTextRef} {...props} $isHighlight={isHighlightExpiryDate} />
}

const StyledHighlightText = css`
  background: -webkit-linear-gradient(#f3c622, #f953c6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
`

const StyledCountdownContent = styled(Flex)<{ $isHighlight }>`
  color: ${({ theme: { colors } }) => colors.text};
  font-size: 12px;
  font-weight: bold;

  div {
    width: 20px;
    text-align: center;

    &.highlight {
      ${({ $isHighlight }) => ($isHighlight ? StyledHighlightText : '')};
    }
  }

  span {
    width: 12px;
    text-align: center;
    color: ${({ theme: { colors } }) => colors.textAlt1};
  }
`

export default BonusItemCountdown
